import { Skeleton, Paper, Box, Divider, Typography } from "@mui/material";

export const OnlineRatingsLoader = () => {
	return (
		<>
			{Array.from({ length: 4 }).map((_, i) => (
				<Paper
					key={i}
					elevation={0}
					sx={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						columnGap: 3,
						backgroundColor: "transparent",
						overflow: "hidden",
						paddingY: "5px",
					}}
				>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							columnGap: 2,
							width: "100%",
						}}
					>
						<Skeleton animation="wave" variant="circular" width={30} height={25} />
						<Skeleton
							animation="wave"
							variant="rectangular"
							sx={{
								borderRadius: 5,
							}}
							width="100%"
							height={10}
						/>
					</Box>

					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "flex-end",
							columnGap: 2,
							width: "180px",
						}}
					>
						<Skeleton
							animation="wave"
							variant="rectangular"
							sx={{
								borderRadius: 5,
							}}
							width="100%"
							height={10}
						/>
						<Skeleton
							animation="wave"
							variant="rectangular"
							sx={{
								borderRadius: 5,
							}}
							width={80}
							height={30}
						/>
					</Box>
				</Paper>
			))}
		</>
	);
};

export const CustomerSatisfactionLoader = () => {
	return (
		<>
			<Skeleton sx={{ borderRadius: 1 }} animation="wave" variant="rectangular" width={"100%"} height={150} />
			<Box
				sx={{
					paddingTop: "0.5rem",
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<Skeleton
					sx={{
						borderRadius: "4px",
					}}
					animation="wave"
					variant="rectangular"
					width={50}
					height={13}
				/>
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						columnGap: 1,
					}}
				>
					<Skeleton
						sx={{
							borderRadius: "4px",
						}}
						animation="wave"
						variant="rectangular"
						width={40}
						height={13}
					/>
					<Skeleton
						sx={{
							borderRadius: "4px",
						}}
						animation="wave"
						variant="rectangular"
						width={40}
						height={13}
					/>
					<Skeleton
						sx={{
							borderRadius: "4px",
						}}
						animation="wave"
						variant="rectangular"
						width={40}
						height={13}
					/>
				</Box>
			</Box>
		</>
	);
};

export const SalespersonOfMonthLoader = () => {
	return (
		<Box
			sx={{
				width: "100%",
				overflow: "hidden",
			}}
		>
			<Skeleton
				sx={{
					borderTopRightRadius: "15px",
					borderTopLeftRadius: "15px",
				}}
				animation="wave"
				variant="rectangular"
				width={"100%"}
				height={"160px"}
			/>
			<Box
				sx={{
					padding: "0.5rem 2rem",
					border: "solid 1px rgba(0, 0, 0, 0.11)",
					borderBottomRightRadius: "15px",
					borderBottomLeftRadius: "15px",
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						columnGap: 1,
					}}
				>
					<Skeleton animation="wave" variant="circular" width={45} height={45} />
					<div>
						<Skeleton
							sx={{
								marginBottom: "0.2rem",
								borderRadius: "4px",
							}}
							animation="wave"
							variant="rectangular"
							width={80}
							height={10}
						/>
						<Skeleton
							sx={{
								marginTop: "0.2rem",
								borderRadius: "4px",
							}}
							animation="wave"
							variant="rectangular"
							width={80}
							height={10}
						/>
					</div>
				</Box>
				<Skeleton
					sx={{
						borderRadius: 5,
					}}
					animation="wave"
					variant="rectangular"
					width={150}
					height={57}
				/>
			</Box>
		</Box>
	);
};

export const BirthdaysOfMonthLoader = () => {
	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
			}}
		>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					columnGap: 1,
					width: "190px",
					height: "42px",
					border: "solid 1px rgba(0, 0, 0, 0.11)",
					borderRadius: "16px",
					paddingLeft: "6px",
				}}
			>
				<Skeleton animation="wave" variant="circular" width={30} height={30} />
				<div>
					<Skeleton
						sx={{
							marginBottom: "0.2rem",
							borderRadius: "2px",
						}}
						animation="wave"
						variant="rectangular"
						width={80}
						height={7}
					/>
					<Skeleton
						sx={{
							marginTop: "0.2rem",
							borderRadius: "2px",
						}}
						animation="wave"
						variant="rectangular"
						width={80}
						height={7}
					/>
				</div>
			</Box>

			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					columnGap: 1,
					width: "190px",
					height: "42px",
					border: "solid 1px rgba(0, 0, 0, 0.11)",
					borderRadius: "16px",
					paddingLeft: "6px",
				}}
			>
				<Skeleton animation="wave" variant="circular" width={30} height={30} />
				<div>
					<Skeleton
						sx={{
							marginBottom: "0.2rem",
							borderRadius: "2px",
						}}
						animation="wave"
						variant="rectangular"
						width={80}
						height={7}
					/>
					<Skeleton
						sx={{
							marginTop: "0.2rem",
							borderRadius: "2px",
						}}
						animation="wave"
						variant="rectangular"
						width={80}
						height={7}
					/>
				</div>
			</Box>
		</Box>
	);
};

export const NotificationsLoader = () => {
	return (
		<>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
				}}
			>
				<Skeleton animation="wave" variant="circular" width={50} height={50} />
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						rowGap: "3px",
						paddingLeft: "0.5rem",
					}}
				>
					<Skeleton
						sx={{
							borderRadius: "4px",
						}}
						animation="wave"
						variant="rectangular"
						width={250}
						height={10}
					/>
					<Skeleton
						sx={{
							borderRadius: "4px",
						}}
						animation="wave"
						variant="rectangular"
						width={100}
						height={10}
					/>
					<Skeleton
						sx={{
							borderRadius: "4px",
						}}
						animation="wave"
						variant="rectangular"
						width={50}
						height={10}
					/>
				</Box>
			</Box>
			<Divider
				sx={{
					margin: "0.5rem 0 0.5rem 3.7rem",
				}}
			/>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
				}}
			>
				<Skeleton animation="wave" variant="circular" width={50} height={50} />
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						rowGap: "3px",
						paddingLeft: "0.5rem",
					}}
				>
					<Skeleton
						sx={{
							borderRadius: "4px",
						}}
						animation="wave"
						variant="rectangular"
						width={250}
						height={10}
					/>
					<Skeleton
						sx={{
							borderRadius: "4px",
						}}
						animation="wave"
						variant="rectangular"
						width={100}
						height={10}
					/>
					<Skeleton
						sx={{
							borderRadius: "4px",
						}}
						animation="wave"
						variant="rectangular"
						width={50}
						height={10}
					/>
				</Box>
			</Box>
		</>
	);
};

export const TipsAndTricksLoader = () => {
	const text = [
		{
			width: 120,
		},
		{
			width: 110,
		},
		{
			width: 100,
		},
		{
			width: 80,
		},
		{
			width: 90,
		},
	];
	return (
		<>
			<Skeleton
				sx={{
					margin: "0.5rem auto",
					borderRadius: "4px",
				}}
				animation="wave"
				variant="rectangular"
				width={60}
				height={20}
			/>
			<Typography
				sx={{
					fontSize: "13.5px",
					fontWeight: "600",
					margin: "0.3rem auto",
					width: "120px",
				}}
			>
				{text.map((item, i) => (
					<Skeleton
						key={i}
						sx={{
							marginBottom: "0.2rem",
							borderRadius: "4px",
						}}
						animation="wave"
						variant="rectangular"
						width={item.width}
						height={10}
					/>
				))}
			</Typography>

			<Skeleton
				sx={{
					marginTop: "1rem",
					borderRadius: "4px",
				}}
				animation="wave"
				variant="rectangular"
				width={40}
				height={15}
			/>
		</>
	);
};
